export default __webpack_public_path__ + "static/media/bank.32cfceb0.svg";